import * as React from 'react';

import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import "./App.css";

import MyForm from "./MyForm";

import config from "./config";

const stripePromise = loadStripe(config.stripe.apiKey);

const App: React.FC = () => (
  <div className="pos-trial">
    <h2 className="pos-h2">Book a trial of <i>pos</i>Chair 1</h2>
    <Elements stripe={stripePromise}>
      <MyForm />
    </Elements>
  </div>
);

export default App;
